import { z } from 'zod';

export type CalculateVenueCo2Dto = z.infer<typeof calculateVenueCo2DtoSchema>;

export const calculateVenueCo2DtoSchema = z.object({
  unit: z.string().optional(),
  score: z.number().or(z.string()),
  events: z
    .object({
      score: z.number(),
    })
    .optional(),
  structure: z
    .object({
      unit: z.string(),
      completion: z.number(),
      score: z.number(),
      sectors: z.object({
        site: z.object({
          completion: z.number(),
          score: z.number(),
          categories: z.object({
            scenography: z.object({ score: z.number() }),
            material: z.object({ score: z.number() }),
            building: z.object({ score: z.number() }),
            energy: z.object({ score: z.number() }),
            water: z.object({ score: z.number() }),
            waste: z.object({ score: z.number() }),
            equipment: z.object({ score: z.number() }),
          }),
        }),
        team: z.object({
          completion: z.number(),
          score: z.number(),
          categories: z.object({
            transport: z.object({ score: z.number() }),
            catering: z.object({ score: z.number() }),
          }),
        }),
        public: z.object({
          completion: z.number(),
          score: z.number(),
          categories: z.object({
            catering: z.object({ score: z.number() }),
            digital: z.object({ score: z.number() }),
          }),
        }),
      }),
    })
    .optional(),
});
